import type { API } from 'chessboard/api/config/types';
import type JCE from '@chesscom/js-chess-engine';

/**
 * Create the getHeaders method.
 */
export function createGetHeaders(context: API.Context) {
  /**
   * Get the PGN headers.
   */
  return function getHeaders(): JCE.PGNHeaders {
    const { game } = context;

    return game.headers();
  };
}
